// Utility functions for formatting user-related display values

/**
 * Convert a raw identifier (like an email) into a user-friendly display name.
 * Examples:
 *  - "ratheesh.karnan@techjays.com" -> "Ratheesh Karnan"
 *  - "john_doe" -> "John Doe"
 *  - "JANE-DOE" -> "Jane Doe"
 */
export function formatDisplayName(raw: string | null | undefined): string {
  if (!raw) {
    return "User";
  }

  let base = raw.trim();

  // If it's an email, use the part before "@"
  const atIndex = base.indexOf("@");
  if (atIndex > 0) {
    base = base.slice(0, atIndex);
  }

  // Split on common separators and filter out empty parts
  const parts = base
    .split(/[.\-_]+/g)
    .map((p) => p.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    return "User";
  }

  const capitalized = parts.map((part) => {
    if (part.length === 1) {
      return part.toUpperCase();
    }
    return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
  });

  return capitalized.join(" ");
}


